/**
 * Loyalty Info Replacer Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var virtueFusionService = require('modules/services/vf.service');
    var BaseModel = require('common/base.model');

    var _getMinValue = function(data) {
        return _.findWhere(data.scheme.redemptionBalances.minBalances, {category: 'BONUS'}).value;
    };

    module.exports = BaseModel.extend({

        sync: function(method, model, options) {
            var isCache = options.isCacheable && this.request && this.request.state() === 'resolved';

            if (method === 'read') {
                if (this.request && this.request.state() === 'pending' || isCache) {
                    this.request
                        .done(options.success)
                        .fail(options.error);
                } else {
                    this.request = virtueFusionService
                        .getLoyaltyInfo()
                        .done(options.success)
                        .fail(options.error);
                }
            }
        },

        parse: function(response) {
            response.data.minBonusBalance = _getMinValue(response.data);

            return response;
        }

    });
});
